import { render, staticRenderFns } from "./Soluciones.vue?vue&type=template&id=70595d7c&scoped=true&"
import script from "./Soluciones.vue?vue&type=script&lang=js&"
export * from "./Soluciones.vue?vue&type=script&lang=js&"
import style0 from "./Soluciones.vue?vue&type=style&index=0&id=70595d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70595d7c",
  null
  
)

export default component.exports